import { baseAPI } from '~shared/api/base-api';

export interface BulkEnrollmentPaymentMethodResult {
  studentId: string;
  parentId?: string;
  paymentMethodId?: string;
  paymentMethodType?: string;
  error?: string;
}

export interface ResolveBulkEnrollmentPaymentMethodsResponse {
  results: BulkEnrollmentPaymentMethodResult[];
}

export const resolveBulkEnrollmentPaymentMethods = async (params: {
  locationId: string;
  studentIds: string[];
}): Promise<ResolveBulkEnrollmentPaymentMethodsResponse> => {
  const response =
    await baseAPI.post<ResolveBulkEnrollmentPaymentMethodsResponse>(
      '/payment-processor/bulk-enrollment-payment-methods',
      {
        locationId: params.locationId,
        studentIds: params.studentIds,
      },
    );

  return response.data;
};
